import React, { Component } from "react";
import { Link } from "react-router-dom";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";


import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Creators as DocumentsActions } from "store/ducks/documents";

import { Form, Loading } from "components";
import Modal from "pages/Documents/components/Modal";

const MySwal = withReactContent(Swal);
class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { loading, onChange } = this.props;

    if (oldProps.loading && !loading && oldProps.data !== this.props.data) {
      this.setState({ data: { ...this.props.data } });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleApprove = async () => {
    const { data } = this.state;
    const { approveDocumentRequest, filters } = this.props;

    const approve = await MySwal.fire({
      title: "Deseja mesmo aprovar?",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Aprovar'
    });

    if (!approve.isConfirmed) return;

    !!approve && approveDocumentRequest(data.id, {
      situation: "approved",
      filters,
    }, '/professionals/documents');
  };

  handleRepprove = async () => {
    const { data } = this.state;
    const { repproveDocumentRequest, filters } = this.props;

    let selected = null;

    const reason = await MySwal.fire({
      title: "Qual o motivo da Reprovação?",
      html: <Modal onSelect={(id) => (selected = id)} />,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Reprovar'
    });

    if (!reason.isConfirmed) return;

    if (selected === null) {
      this.handleRepprove();
      return;
    }

    !!reason &&
      repproveDocumentRequest(data.id, {
        user_document_request_reason_id: selected,
        situation: "rejected",
        filters,
      }, '/professionals/documents');
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSave } = this.props;

    onSave();
  };

  render() {
    const { data } = this.state;
    const { saving, approve, repprove, filters } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSubmit}>
        <h3 className="form-title">Detalhes do Documento</h3>

        {data.situation === "rejected" &&
          data.document_request_reason !== null && (
            <div className="alert alert-warning">
              <h4>Reprovado</h4>

              {data.document_request_reason.title}
            </div>
          )}

        {data.document.id !== null && data.document.documentable && (
          <img
            className="image"
            src={data.document.presigned_image_url}
            alt={`Imagem do documento de ${data.document.documentable.name}`}
          />
        )}

        <div className="buttons">
          <Link to={{
            pathname: "/professionals/documents",
            filters,
            }} className="button-cancel">
            Cancelar
          </Link>

          {data.situation !== 'rejected' && data.situation !== 'approved' && (
            <Form.Button
              type="button"
              className="button-cancel"
              onClick={this.handleRepprove}
              disabled={saving}
            >
              {repprove.loading ? (
                <Loading type="btn" size="small" text="Reprovando..." />
              ) : (
                "Reprovar"
              )}
            </Form.Button>
          )}

          {data.situation !== 'rejected' && data.situation !== 'approved' && (
            <Form.Button
              type="button"
              className="button-save margin-right-15"
              onClick={this.handleApprove}
              disabled={saving}
            >
              {approve.loading ? (
                <Loading type="btn" size="small" text="Aprovando..." />
              ) : (
                "Aprovar"
              )}
            </Form.Button>
          )}
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  approve: state.documents.approve,
  repprove: state.documents.repprove,
});

const mapActions = (dispatch) => bindActionCreators(DocumentsActions, dispatch);

export default connect(mapState, mapActions)(CustomForm);
